import { getSimDetails, tccRegisterApi, byPassVerification } from "../api/api";
import { SequenceManagerAction } from "./SequenceManagerAction";

const AbsherVerificationAction = {
  GET_SIM_DETAILS_SUCCESS: "GET_SIM_DETAILS_SUCCESS",
  TCC_REGISTRATION_SUCCESS: "TCC_REGISTRATION_SUCCESS",
  GET_SIM_DETAILS_FAILURE: "GET_SIM_DETAILS_FAILURE",
  TCC_REGISTRATION_FAILURE: "TCC_REGISTRATION_FAILURE",
  ABSHER_VERIFICATION_COMPLETE: "ABSHER_VERIFICATION_COMPLETE",
  BYPASS_VERIFICATION_SUCCESS: "BYPASS_VERIFICATION_SUCCESS",
  BYPASS_VERIFICATION_FAILURE: "BYPASS_VERIFICATION_FAILURE"
}

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let getSimDetailsCounter = 0;

const getSimTypeDetails = (NewStack: any) => {
  return function (dispatch: any) {
    getSimDetails(NewStack)
      .then((response) => {
        console.log(response);
        dispatch({ type: AbsherVerificationAction.GET_SIM_DETAILS_SUCCESS, payload: response });
      })
      .catch((err) => {
        const config = Object.assign(err?.config, { serviceName: 'getESimDetails' });
        const error = { ...err, config };

        if (error?.response?.status) {
          dispatch({ type: AbsherVerificationAction.GET_SIM_DETAILS_SUCCESS, payload: error?.response });
        } else {
          ++getSimDetailsCounter
          if (getSimDetailsCounter < retryCount) {
            const objData = JSON.parse(error?.config?.data);
            dispatch(getSimTypeDetails(objData?.NewStack));
          } else {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          }
        }
      })
  }
}

const tccRegisterDetails = (IAMToken: any, requestType: any, sim: any, imsi: any, msisdnNumber: any, idNumber: any, Nationality: any, payType: any, appToken: any, exceptionFlag: any, newStack: any) => {
  sessionStorage.removeItem('nafathAppToken'); // remove nafath app token from session storage

  return function (dispatch: any) {
    tccRegisterApi(IAMToken, requestType, sim, imsi, msisdnNumber, idNumber, Nationality, payType, appToken, exceptionFlag, newStack)
      .then((response) => {
        dispatch({ type: AbsherVerificationAction.TCC_REGISTRATION_SUCCESS, payload: response });
      })
      .catch((error) => {
        //Display error
        if (error?.response) {
          dispatch({ type: AbsherVerificationAction.TCC_REGISTRATION_SUCCESS, payload: error?.response });
        } else {
          // dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          dispatch({ type: AbsherVerificationAction.TCC_REGISTRATION_SUCCESS, payload: error });
        }
      })
  }
}

const byPassVerificationCall = () => {
  return function (dispatch: any) {
    byPassVerification().then((response) => {
      dispatch({ type: AbsherVerificationAction.BYPASS_VERIFICATION_SUCCESS, payload: response });
    })
      .catch((error) => {
        //Display error
        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
      })
  }
}

const storeTccRegisterDetails = (IAMToken: any, simDetails: any, tccRegisterResponse: any, ocId: any, nafathOption: any) => {
  return function (dispatch: any) {
    dispatch({ type: AbsherVerificationAction.ABSHER_VERIFICATION_COMPLETE, payload: { IAMToken: IAMToken, simDetails: simDetails, tccRegisterResponse: tccRegisterResponse, ocId: ocId, nafathOption: nafathOption } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['AbsherVerification'] });
  }
}

export { AbsherVerificationAction, getSimTypeDetails, tccRegisterDetails, storeTccRegisterDetails, byPassVerificationCall };
